module.exports = __webpack_public_path__ + "static/media/ortho-image2@3x.38de8e7b.png";